function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { Cable, GhostChannel } from "../cable/index.js";
import { ActionCableProtocol } from "../action_cable/index.js";
import { JSONEncoder } from "../encoder/index.js";
import { NoopLogger } from "../logger/index.js";
import { WebSocketTransport } from "../websocket/index.js";
import { Monitor, backoffWithJitter } from "../monitor/index.js";
import { SubscriptionRejectedError } from "../protocol/index.js";
export var DEFAULT_OPTIONS = {
  protocol: 'actioncable-v1-json',
  pingInterval: 3000,
  maxReconnectAttempts: Infinity,
  maxMissingPings: 2,
  logLevel: 'warn',
  lazy: true
};
export function createCable(url, opts) {
  if (_typeof(url) === 'object' && typeof opts === 'undefined') {
    opts = url;
    url = undefined;
  }

  opts = opts || {};
  if (!url && !opts.transport) throw Error('URL or transport must be specified');
  opts = Object.assign({}, DEFAULT_OPTIONS, opts);
  var _opts = opts,
      protocol = _opts.protocol,
      websocketImplementation = _opts.websocketImplementation,
      websocketFormat = _opts.websocketFormat,
      websocketOptions = _opts.websocketOptions,
      logLevel = _opts.logLevel,
      logger = _opts.logger,
      transport = _opts.transport,
      encoder = _opts.encoder,
      lazy = _opts.lazy,
      monitor = _opts.monitor,
      pingInterval = _opts.pingInterval,
      reconnectStrategy = _opts.reconnectStrategy,
      maxMissingPings = _opts.maxMissingPings,
      maxReconnectAttempts = _opts.maxReconnectAttempts,
      subprotocol = _opts.subprotocol,
      tokenRefresher = _opts.tokenRefresher;
  logger = logger || new NoopLogger(logLevel);
  if (typeof protocol === 'string') subprotocol = subprotocol || protocol;

  if (protocol === 'actioncable-v1-json') {
    protocol = new ActionCableProtocol({
      logger: logger
    });
    encoder = encoder || new JSONEncoder();
    websocketFormat = websocketFormat || 'text';
  } else if (protocol === 'actioncable-v1-msgpack') {
    protocol = new ActionCableProtocol({
      logger: logger
    });
    websocketFormat = 'binary';

    if (!encoder) {
      throw Error('Msgpack encoder must be specified explicitly. Use `@anycable/msgpack-encoder` package or build your own');
    }
  } else if (protocol === 'actioncable-v1-protobuf') {
    protocol = new ActionCableProtocol({
      logger: logger
    });
    websocketFormat = websocketFormat || 'binary';

    if (!encoder) {
      throw Error('Protobuf encoder must be specified explicitly. Use `@anycable/protobuf-encoder` package or build your own');
    }
  } else if (typeof protocol === 'string') {
    throw Error("Protocol is not supported yet: ".concat(protocol));
  }

  if (!protocol) throw Error('Protocol must be specified');
  transport = transport || new WebSocketTransport(url, {
    websocketImplementation: websocketImplementation,
    websocketOptions: websocketOptions,
    subprotocol: subprotocol,
    format: websocketFormat
  });
  reconnectStrategy = reconnectStrategy || backoffWithJitter(pingInterval);

  if (monitor !== false) {
    monitor = monitor || new Monitor({
      pingInterval: pingInterval,
      reconnectStrategy: reconnectStrategy,
      maxMissingPings: maxMissingPings,
      maxReconnectAttempts: maxReconnectAttempts,
      logger: logger
    });
  }

  var cable = new Cable({
    protocol: protocol,
    transport: transport,
    encoder: encoder,
    logger: logger,
    lazy: lazy
  });

  if (monitor) {
    monitor.watch(cable);
    cable.monitor = monitor;
  }

  if (tokenRefresher) {
    watchForExpiredToken(cable, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return tokenRefresher(transport);

            case 3:
              _context.next = 9;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              logger.error('Failed to refresh authentication token: ' + _context.t0);
              return _context.abrupt("return", false);

            case 9:
              // Initiate cable connection.
              // No need to wait for it to complete, it could
              // fail due to network errors (which is not our responsibility)
              cable.connect().catch(function () {});
              return _context.abrupt("return", true);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    })));
  }

  return cable;
}

function watchForExpiredToken(cable, callback) {
  var attempted = false;
  cable.on('connect', function () {
    return attempted = false;
  });
  cable.on('close', /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ev) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (ev) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              if (!attempted) {
                _context2.next = 5;
                break;
              }

              cable.logger.warn('Token auto-refresh is disabled', ev);
              return _context2.abrupt("return");

            case 5:
              if (!(ev.reason === 'token_expired')) {
                _context2.next = 9;
                break;
              }

              attempted = true;
              _context2.next = 9;
              return callback();

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
} // Wrapper over ActionCableChannel that acts like an Action Cable subscription object


var ActionCableSubscription = /*#__PURE__*/function () {
  function ActionCableSubscription(channel) {
    _classCallCheck(this, ActionCableSubscription);

    this.channel = channel;
  }

  _createClass(ActionCableSubscription, [{
    key: "notify",
    value: function notify(callback) {
      if (typeof this[callback] !== 'function') return;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      this[callback].apply(this, args);
    }
  }, {
    key: "perform",
    value: function perform(action) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.channel.perform(action, data);
    }
  }, {
    key: "send",
    value: function send(data) {
      this.channel.send(data);
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.channel.identifier;
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      return this.channel.disconnect();
    }
  }]);

  return ActionCableSubscription;
}();

var ActionCableChannel = /*#__PURE__*/function (_GhostChannel) {
  _inherits(ActionCableChannel, _GhostChannel);

  var _super = _createSuper(ActionCableChannel);

  function ActionCableChannel(channelName, params, mixin) {
    var _this;

    _classCallCheck(this, ActionCableChannel);

    _this = _super.call(this, channelName, params);
    _this.subscription = new ActionCableSubscription(_assertThisInitialized(_this));
    Object.assign(_this.subscription, mixin);

    _this.on('connect', function () {
      return _this.subscription.notify('connected');
    });

    _this.on('disconnect', function () {
      return _this.subscription.notify('disconnected', {
        allowReconnect: true
      });
    });

    _this.on('message', function (val) {
      return _this.subscription.notify('received', val);
    });

    _this.on('close', function (err) {
      if (err && err instanceof SubscriptionRejectedError) {
        _this.subscription.notify('rejected');
      } else {
        _this.subscription.notify('disconnected', {
          allowReconnect: false
        });
      }
    });

    return _this;
  }

  return ActionCableChannel;
}(GhostChannel);

export var ActionCableSubscriptions = /*#__PURE__*/function () {
  function ActionCableSubscriptions(cable) {
    _classCallCheck(this, ActionCableSubscriptions);

    this.cable = cable;
  }

  _createClass(ActionCableSubscriptions, [{
    key: "create",
    value: function create(channel, mixin) {
      var channelName;
      var params;

      if (_typeof(channel) === 'object') {
        channelName = channel.channel;
        delete channel.channel;
        params = channel;
      } else {
        channelName = channel;
        params = {};
      }

      var cableChannel = new ActionCableChannel(channelName, params, mixin);
      cableChannel.subscription.notify('initialized');
      this.cable.subscribe(cableChannel);
      return cableChannel.subscription;
    }
  }]);

  return ActionCableSubscriptions;
}();
export var ActionCableConsumer = function ActionCableConsumer(cable) {
  _classCallCheck(this, ActionCableConsumer);

  this.cable = cable;
  this.subscriptions = new ActionCableSubscriptions(cable);
};
export function createConsumer(url, opts) {
  var cable = createCable(url, opts);
  return new ActionCableConsumer(cable);
}